<template>
    <Head title="Seja Bem Vindo" />

    <section class="grid component-background min-h-screen h-full w-full relative grid-welcome-columns-template">
            <div class="absolute left-0 top-1/2 -translate-y-1/2 z-0 ilustracoes-container">
                <img src="/images/ilustrações.png" class="w-full h-auto" />
            </div>
       <article class="flex flex-col justify-center items-center w-full px-8 relative z-10">
            <img src="/images/logo.png" class="object-cover mt-[-100px] logo-slogan-mobile" />
            <img src="/images/slogan.png" class="object-cover mt-10 max-w-[42%] logo-slogan-mobile" />
        </article>
        <article class="component-background-mobile-deslogado grid sm:justify-center sm:items-center sm:justify-items-center sm:pt-[5vw] sm:pb-[5vw] md:col-start-2">
            <div class="grid sm:rounded-md md:justify-items-center justify-center">
                <!-- <img src="/images/pessoas-home-deslogada-mobile.png" class="w-full pb:hidden" alt=""> -->
                <div class="flex flex-col justify-center items-center">
                    <ul class="grid gap-4 w-full max-w-[50vw] sm:max-w-[400px] px-4 z-20">
                        <Link
                            :href="route('login')">
                            <Button class="min-w-[350px]">
                            Acessar Plataforma
                            </Button>
                        </Link>
                        <Link
                            :href="route('register')">
                            <Button>
                                Primeiro Acesso
                            </Button>
                        </Link>
                        <div class="flex flex-row justify-center gap-x-4 text-white pt-16">
                            <Link v-for="link in hyperLinks1" :key="link.text" :href="route(`${ link.route }`)" class="cursor-pointer">
                                {{ link.text }}
                            </Link>
                        </div>
                    </ul>
                </div>
            </div>
        </article>
        <BottomBar />
    </section>
</template>

<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import ApplicationLogo from "@/Components/ApplicationLogo.vue";
import Article from "@/Components/Article.vue";
import Button from "@/Components/Button.vue";
import BottomBar from "@/Components/BottomBar.vue";


export default {
    components: {
        Head,
        Link,
        ApplicationLogo,
        Article,
        Button,
        BottomBar,
    },

    props: {
        canResetPassword: Boolean,
        canRegister: Boolean,
        status: String,
    },

    data() {
    return {
      hyperLinks1: [
        {
            route: "contact",
            text: "Fale Conosco",
        },
      ],
    };
  },
};
</script>
<style scoped>
    @media (min-width: 769px) {
        .grid-welcome-columns-template {
            grid-template-columns: 2fr minmax(406px, 40vw);
        }
    }

    /* Ilustrações responsivo */
    .ilustracoes-container { width: 250px; }

    @media (min-width: 1435px) {
        .ilustracoes-container { display: none; }
        .logo-slogan-mobile { display: none; }
    }
</style>
